export const TableFormExpand = Object.freeze({
    Yes: 'yes',
    No: 'no',
});
